import React, { useState, useEffect } from "react";
import { useGlobal } from "../context/ContenedorGlobal";
import API_URL from "../config";
import "../styles/Formularios.css";
import "../styles/ReportesPorCategoria.css";
import InputSelectGenerico from "./InputSelectGenerico";
import InputGenerico from "./InputGenerico";
import { useApiFetch } from "../utils/apiFetch";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import logo from "../assets/logo_sict.png";

function RegistrarServicios() {

    const { setModuloActual, setSubModuloActual, logout } = useGlobal();
    const [error, setError] = useState("");
    const [success, setSuccess] = useState("");
    const [servicio, setServicio] = useState("");
    const [idServicio, setIdServicio] = useState("");
    const [idServicioTic, setIdServicioTic] = useState("");
    const [servicioTic, setServicioTic] = useState("");
    const [idSubServicioTic, setIdSubServicioTic] = useState("");
    const [subServicioTic, setSubServicioTic] = useState("");
    const [bloqA, setBloqA] = useState(false);
    const [bloqB, setBloqB] = useState(false);
    const apiFetch = useApiFetch();
    const [vista, setVista] = useState("opciones");
    const [resultados, setResultados] = useState([]);
    const [seleccionado, setSeleccionado] = useState(null);
    const [mensaje, setMensaje] = useState("");

    // Efecto secundario para volver a los inputs solo lectura una vez elegido un valor
    useEffect(() => {       // Para el servicio TIC
        if (idServicioTic) {
            setBloqA(true); // Bloquear si hay dato
        } else {
            setBloqA(false);  // Desbloquear si está vacío
        }
    }, [idServicioTic]);

    useEffect(() => {       // Para el sub servicio TIC
        if (idSubServicioTic) {
            setBloqB(true); // Bloquear si hay dato
        } else {
            setBloqB(false);  // Desbloquear si está vacío
        }
    }, [idSubServicioTic]);

    // Función asincrona para registrar el servicio
    const handleRegistrarServicio = async (e) => {
        e.preventDefault();

        try {

            const payload = {
                id_servicio_tic: idServicioTic,
                id_sub_servicio_tic: idSubServicioTic,
                servicio_tic: servicioTic,
                sub_servicio_tic: subServicioTic,
                servicio: servicio
            };

            const data = await apiFetch("registrar_servicio.php", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(payload)
            }, logout);

            if (data.status === "ok") {
                setSuccess("Servicio registrado correctamente.");
                setTimeout(() => {
                    setModuloActual("Software");
                    setSubModuloActual(null);
                }, 3000);
            } else {
                setError("Error al registrar el servicio: " + (data.message || "Error desconocido."));
                setTimeout(() => {
                    setModuloActual("Software");
                    setSubModuloActual(null);
                }, 3000);
            }
        } catch (err) {
            setError("Error de conexión con el servidor: " + err.message);
        }

    };

    // Función para consultar los Servicios TIC
    const consultarServiciosTic = async () => {
        try {
            const data = await apiFetch("consultar_servicios_tic_41.php", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({})
            }, logout);

            if (data.status === "ok") {
                setResultados(data.data);
                setSuccess("Consulta de Servicios TIC realizada correctamente.");
                setVista("resultados1");

                // Limpiar el mensaje después de 2 segundos
                setTimeout(() => {
                    setSuccess("");
                }, 2000);
            } else {
                setError("Error en la consulta: " + (data.message || "Error desconocido."));
            }
        } catch (err) {
            setError("Error de conexión: " + err.message);
        }
    };

    // Función para consultar los Sub Servicios TIC
    const consultarSubServiciosTic = async () => {
        try {
            const data = await apiFetch("consultar_sub_servicios_tic_41.php", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({})
            }, logout);

            if (data.status === "ok") {
                setResultados(data.data);
                setSuccess("Consulta de Sub Servicios TIC realizada correctamente.");
                setVista("resultados2");

                // Limpiar el mensaje después de 2 segundos
                setTimeout(() => {
                    setSuccess("");
                }, 2000);
            } else {
                setError("Error en la consulta: " + (data.message || "Error desconocido."));
            }
        } catch (err) {
            setError("Error de conexión: " + err.message);
        }
    };

    // Función parar consultar los Servicios
    const consultarServicios = async () => {
        try {
            const data = await apiFetch("consultar_servicios_41.php", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({})
            }, logout);

            if (data.status === "ok") {
                setResultados(data.data);
                setSuccess("Consulta de Servicios realizada correctamente.");
                setVista("resultados3");

                // Limpiar el mensaje después de 2 segundos
                setTimeout(() => {
                    setSuccess("");
                }, 2000);
            } else {
                setError("Error en la consulta: " + (data.message || "Error desconocido."));
            }
        } catch (err) {
            setError("Error de conexión: " + err.message);
        }
    };


    // Vuelve a las const vacias para reiniciar el formulario
    const handleLimpiar = () => {
        setIdServicioTic("");
        setServicioTic("");
        setIdSubServicioTic("");
        setSubServicioTic("");
        setServicio("");
    };

    // Vuelve a las const vacias para reiniciar el formulario
    const handleRegresar = () => {
        setIdServicioTic("");
        setServicioTic("");
        setIdSubServicioTic("");
        setSubServicioTic("");
        setServicio("");
        setVista("opciones");
    };

    // Función para regresar a las botones de consultar
    const handleRegresarConsultar = () => {
        setIdServicioTic("");
        setServicioTic("");
        setIdSubServicioTic("");
        setSubServicioTic("");
        setIdServicio("");
        setServicio("");
        setVista("consultar");
    };

    // Función para exportar en formato CSV
    const handleExportarCSV = (datos, columnas, nombreArchivo) => {
        if (!datos.length) return;

        // Encabezados
        const encabezados = columnas.map(col => col.label).join(",");
        const filas = datos.map(item =>
            columnas.map(col => `"${item[col.key] ?? ""}"`).join(",")
        );

        const contenido = [encabezados, ...filas].join("\n");

        // Crear archivo descargable
        const BOM = "\uFEFF"; // UTF-8 BOM
        const blob = new Blob([BOM + contenido], { type: "text/csv;charset=utf-8;" });
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", nombreArchivo);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };


    // Función para exportar en formato PDF
    const handleExportarPDF = (datos, columnas, titulo, nombreArchivo) => {
        if (!datos.length) return;

        const doc = new jsPDF();

        // Logo institucional
        doc.addImage(logo, "PNG", 10, 10, 30, 15);

        // Encabezado
        doc.setFontSize(14);
        doc.text("Secretaría de Infraestructura, Comunicaciones y Transportes", 50, 20);
        doc.setFontSize(12);
        doc.text(titulo, 50, 30);

        doc.setLineWidth(0.5);
        doc.line(10, 40, 200, 40);

        // Tabla
        autoTable(doc, {
            startY: 50,
            head: [columnas.map(col => col.label)],
            body: datos.map(item => columnas.map(col => item[col.key]))
        });

        // Pie de página
        doc.setFontSize(10);
        doc.text("© 2026 SIGBI-712. Todos los derechos reservados.", 10, 290);

        doc.save(nombreArchivo);
    };

    return (
        <div className="sesion-form">

            {vista === "opciones" && (
                <div className="reportes-botones">
                    <button onClick={() => setVista("registrar")}>
                        Registrar<br />Servicio
                    </button>
                    <button onClick={() => setVista("consultar")}>
                        Consultar<br />Servicios
                    </button>
                </div>
            )}

            {vista === "registrar" && (
                <div >
                    {error && <div className="error">{error}</div>}
                    {success && <div className="success">{success}</div>}

                    {/* Selección de servicio TIC */}
                    <InputSelectGenerico
                        idSeleccionado={idServicioTic}
                        setIdSeleccionado={setIdServicioTic}
                        label="Servicio TIC"
                        apiUrl={`consultar_servicios_tic.php`}
                        valueField="id_servicio_tic"
                        displayField="servicio_tic"
                        readOnly={bloqA}
                        showDefaultOption={true}
                        defaultOptionText="Seleccione el Servicio TIC"
                    />

                    {/* Selección de sub servicio TIC, solo si ya hay servicio TIC */}
                    {idServicioTic && (
                        <InputSelectGenerico
                            idSeleccionado={idSubServicioTic}
                            setIdSeleccionado={setIdSubServicioTic}
                            label="Sub Servicio TIC"
                            apiUrl={`consultar_sub_servicios_tic.php?id_servicio_tic=${idServicioTic}`}
                            valueField="id_sub_servicio_tic"
                            displayField="sub_servicio_tic"
                            readOnly={bloqB}
                            showDefaultOption={true}
                            defaultOptionText="Seleccione el Sub Servicio TIC"
                        />
                    )}

                    {/* Campo para registrar el nuevo servicio */}
                    {idServicioTic && idSubServicioTic && (
                        <InputGenerico
                            value={servicio}
                            setValue={setServicio}
                            label="Servicio"
                            maxLength={50}
                            allowedChars="A-Z0-9. "
                            transform="uppercase"
                            placeholder="Nombre del nuevo servicio"
                            title="Máximo 50 caracteres"
                        />
                    )}

                    <div className="form-buttons">

                        {/* Botón Registrar Servicio */}
                        {(idServicioTic && idSubServicioTic && servicio) && (
                            <button type="button" onClick={handleRegistrarServicio}>
                                Registrar<br></br>Servicio
                            </button>
                        )}

                        <button
                            type="button"
                            onClick={handleLimpiar}
                            disabled={!idServicioTic}   // deshabilitado si no hay selección
                        >
                            Limpiar
                        </button>

                        <button onClick={handleRegresar}>Regresar</button>
                    </div>

                </div>
            )}

            {vista === "consultar" && (
                <>
                    <div className="reportes-botones">
                        <button onClick={consultarServiciosTic}>
                            Servicios<br />Tic
                        </button>
                        <button onClick={consultarSubServiciosTic}>
                            Sub Servicios<br />Tic
                        </button>
                        <button onClick={consultarServicios}>
                            Servicios
                        </button>
                    </div>

                    <div className="form-buttons">
                        <button onClick={handleRegresar}>Regresar</button>

                    </div>
                </>
            )}

            {vista === "resultados1" && (
                <>
                    <h2>Lista de Servicios TIC</h2>
                    {mensaje && <p className="error">{mensaje}</p>}

                    <table className="tabla-estandar seleccion-unica">
                        <thead>
                            <tr>
                                {/*<th>Seleccionar</th>*/}
                                {/*<th>ID Servicio TIC</th>*/}
                                <th>Servicio TIC</th>
                            </tr>
                        </thead>
                        <tbody>
                            {resultados.map((item) => (
                                <tr key={item.id_servicio_tic}>
                                    {/*<td data-label="Seleccionar">
                                        <input
                                            type="checkbox"
                                            checked={seleccionado === item.id_servicio_tic}
                                            onChange={() => {
                                                const nuevo = seleccionado === item.id_servicio_tic ? null : item.id_servicio_tic;
                                                setSeleccionado(nuevo);
                                            }}
                                        />
                                    </td>*/}
                                    {/*<td data-label="ID Servicio TIC">{item.id_servicio_tic}</td>*/}
                                    <td data-label="Servicio TIC">{item.servicio_tic}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>

                    <div className="form-buttons">

                        <button
                            className="exportar"
                            onClick={() => handleExportarCSV(
                                resultados,
                                [
                                    { key: "id_servicio_tic", label: "ID Servicio TIC" },
                                    { key: "servicio_tic", label: "Servicio TIC" }
                                ],
                                "servicios_tic.csv"
                            )}
                        >
                            Exportar<br></br>en CSV
                        </button>

                        <button
                            className="exportar"
                            onClick={() => handleExportarPDF(
                                resultados,
                                [
                                    { key: "id_servicio_tic", label: "ID Servicio TIC" },
                                    { key: "servicio_tic", label: "Servicio TIC" }
                                ],
                                "Listado de Servicios TIC",
                                "servicios_tic.pdf"
                            )}
                        >
                            Exportar<br></br>en PDF
                        </button>

                        <button onClick={handleRegresarConsultar}>Regresar</button>

                    </div>
                </>
            )}

            {vista === "resultados2" && (
                <>
                    <h2>Lista de Sub Servicios TIC</h2>
                    {mensaje && <p className="error">{mensaje}</p>}

                    <table className="tabla-estandar seleccion-unica">
                        <thead>
                            <tr>
                                {/*<th>Seleccionar</th>*/}
                                {/*<th>ID Sub Servicio TIC</th>*/}
                                <th>Sub Servicio TIC</th>
                                {/*<th>ID Servicio TIC</th>*/}
                            </tr>
                        </thead>
                        <tbody>
                            {resultados.map((item) => (
                                <tr key={item.id_sub_servicio_tic}>
                                    {/*<td data-label="Seleccionar">
                                        <input
                                            type="checkbox"
                                            checked={seleccionado === item.id_sub_servicio_tic}
                                            onChange={() => {
                                                const nuevo = seleccionado === item.id_sub_servicio_tic ? null : item.id_sub_servicio_tic;
                                                setSeleccionado(nuevo);
                                            }}
                                        />
                                    </td>*/}
                                    {/*<td data-label="ID Sub Servicio TIC">{item.id_sub_servicio_tic}</td>*/}
                                    <td data-label="Sub Servicio TIC">{item.sub_servicio_tic}</td>
                                    {/*<td data-label="ID Servicio TIC">{item.id_servicio_tic}</td>*/}
                                </tr>
                            ))}
                        </tbody>
                    </table>

                    <div className="form-buttons">

                        <button
                            className="exportar"
                            onClick={() => handleExportarCSV(
                                resultados,
                                [
                                    { key: "id_sub_servicio_tic", label: "ID Sub Servicio TIC" },
                                    { key: "sub_servicio_tic", label: "Sub Servicio TIC" },
                                    { key: "id_servicio_tic", label: "ID Servicio TIC" }
                                ],
                                "sub_servicios_tic.csv"
                            )}
                        >
                            Exportar<br></br>en CSV
                        </button>

                        <button
                            className="exportar"
                            onClick={() => handleExportarPDF(
                                resultados,
                                [
                                    { key: "id_sub_servicio_tic", label: "ID Sub Servicio TIC" },
                                    { key: "sub_servicio_tic", label: "Sub Servicio TIC" },
                                    { key: "id_servicio_tic", label: "ID Servicio TIC" }
                                ],
                                "Listado de Sub Servicios TIC",
                                "sub_servicios_tic.pdf"
                            )}
                        >
                            Exportar<br></br>en PDF
                        </button>

                        <button onClick={handleRegresarConsultar}>Regresar</button>

                    </div>
                </>
            )}

            {vista === "resultados3" && (
                <>
                    <h2>Lista de Servicios</h2>
                    {mensaje && <p className="error">{mensaje}</p>}

                    <table className="tabla-estandar seleccion-unica">
                        <thead>
                            <tr>
                                {/*<th>Seleccionar</th>*/}
                                {/*<th>ID Servicio</th>*/}
                                <th>Servicio</th>
                                {/*<th>ID Sub Servicio TIC</th>*/}
                            </tr>
                        </thead>
                        <tbody>
                            {resultados.map((item) => (
                                <tr key={item.id_servicio}>
                                    {/*<td data-label="Seleccionar">
                                        <input
                                            type="checkbox"
                                            checked={seleccionado === item.id_servicio}
                                            onChange={() => {
                                                const nuevo = seleccionado === item.id_servicio ? null : item.id_servicio;
                                                setSeleccionado(nuevo);
                                            }}
                                        />
                                    </td>*/}
                                    {/*<td data-label="ID Servicio">{item.id_servicio}</td>*/}
                                    <td data-label="Servicio">{item.servicio}</td>
                                    {/*<td data-label="ID Sub Servicio TIC">{item.id_sub_servicio_tic}</td>*/}
                                </tr>
                            ))}
                        </tbody>
                    </table>

                    <div className="form-buttons">

                        <button
                            className="exportar"
                            onClick={() => handleExportarCSV(
                                resultados,
                                [
                                    { key: "id_servicio", label: "ID Servicio" },
                                    { key: "servicio", label: "Servicio" },
                                    { key: "id_sub_servicio_tic", label: "ID Sub Servicio TIC" }
                                ],
                                "servicios.csv"
                            )}
                        >
                            Exportar<br></br>en CSV
                        </button>

                        <button
                            className="exportar"
                            onClick={() => handleExportarPDF(
                                resultados,
                                [
                                    { key: "id_servicio", label: "ID Servicio" },
                                    { key: "servicio", label: "Servicio" },
                                    { key: "id_sub_servicio_tic", label: "ID Sub Servicio TIC" }
                                ],
                                "Listado de Servicios",
                                "servicios.pdf"
                            )}
                        >
                            Exportar<br></br>en PDF
                        </button>

                        <button onClick={handleRegresarConsultar}>Regresar</button>
                    </div>

                </>
            )}






        </div>
    );
}

export default RegistrarServicios;